import Avatar from "@mui/material/Avatar";
import React, { useContext, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import AdminDeleteTickets from "../../actions/student/AdminDeleteTickets";
import { Check, Delete, MoreVert } from "@material-ui/icons";
import DeleteModal from "../../components/modals/DeleteModal";
import AdminUpdateDoubtRequest from "../../actions/support/AdminUpdateDoubtRequest";
import { AuthContext } from "../../context/AuthContext";
import {
  Pending,
  Chat,
  VideoCall,
  Call
} from "@mui/icons-material";
import DefaultToast from "../../components/toasts/DefaultToast";

import { useTeamData } from "../../actions/team/TeamContext";
import { useActionsContext } from "../../context/ActionsContext";
import NoPermissionModal from "../../components/modals/NoPermissionModal";
import axios from "axios";
import ENDPOINT from "../../context/EndPoint";
import SecurityHeaders from "../../context/SecurityHeaders";
import { useDispatch, useSelector } from "react-redux";
import defaultUser from "../../assets/images/users/user-dummy-img.jpg";
import StatusChip from "../../components/StatusChip";
import { Box, CircularProgress, Modal } from '@mui/material'
import DefaultModal from "../../components/modals/DefaultModal";
const StudentTicketItem = ({ item, Reload, options ,teamList,Statistics }) => {
  const notification = useSelector(
    (state) => state.sendNotification.notification,
  );
  const dispatch = useDispatch();
  const { user } = useContext(AuthContext);
  const [deletemodal, setdeletemodal] = useState(false);
  const [toastdata, setoastdata] = useState(null);
  const [toast, settoast] = useState(false);
  const { permission } = useActionsContext();
  const [nopermission, setnopermission] = useState(false);

  const { deleting, setdeleting } = useActionsContext();

  // console.log(notification);

  useEffect(() => {}, []);
  const [deletedoubtrequestresponse, setdeletedoubtrequestresponse] =
    useState(null);

    const DeleteDoubtRequest = async ({ payload }, ) => {
      dispatch({ type: 'LOADING' });
      setdeleting(true);
    
      const data = new FormData();
      data.append("id", item.id);
      data.append("session", user.SessionId);
    
      try {
        const res = await axios.post(
          ENDPOINT + "admin-delete-doubt-request.php",
          data,
          SecurityHeaders
        );
    
        if (res) {
          if (res.data.status === "success") {
            dispatch({ type: 'DONE_LOADING' });
            setdeletemodal(false);
            setdeletedoubtrequestresponse(res.data);
            Statistics()
          } else {
            dispatch({ 
              type: 'ERROR', 
              payload: res.data.message || 'Failed to delete doubt request' 
            });
          }
        }
      } catch (error) {
        dispatch({ 
          type: 'ERROR', 
          payload: error.message || 'An error occurred while deleting the doubt request' 
        });
      } finally {
        setdeleting(false);
      }
    };

  useEffect(() => {
    setoastdata(deletedoubtrequestresponse);
    if (
      deletedoubtrequestresponse &&
      deletedoubtrequestresponse.status === "success"
    ) {
      Reload();
      setdeletemodal(false);
    }
  }, [deletedoubtrequestresponse]);
  const UpdateRequest = async ({ status }) => {
    try {
      dispatch({ type: 'LOADING' });
      
      const res = await AdminUpdateDoubtRequest({
        payload: {
          notification: notification,
          session: user.SessionId,
          id: item.id,
          status: status,
        
        },
      });

      if (res) {
 
        if (res.status === "success") {
          Statistics();
          Reload();
          dispatch({ type: 'DONE_LOADING' });

        } else {
          dispatch({ type: 'ERROR', payload: 'Update failed' });
        }
      }
    } catch (error) {
      dispatch({ type: 'ERROR', payload: error.message });
    }
  };
  const [deleteResponse, setDeleteResponse] = useState(null);
  const [updateResponse, setUpdateResponse] = useState(null);
  // getting get-team-list.php and assigning to teamlist

  const [openList, setOpenList] = useState(false);

  const getCategoryUI = (category) => {

    switch ((category || "").toLowerCase()) {
  
      case "chat":
        return {
          icon: <Chat style={{ fontSize: 16 }} />,
          className: "bg-primary text-white",
          label: "Chat"
        };
  
      case "zoom":
        return {
          icon: <VideoCall style={{ fontSize: 16 }} />,
          className: "bg-danger text-white",
          label: "Zoom"
        };
  
      case "callback":
        return {
          icon: <Call style={{ fontSize: 16 }} />,
          className: "bg-success text-white",
          label: "Callback"
        };
  
      default:
        return {
          icon: <Pending style={{ fontSize: 16 }} />,
          className: "bg-secondary text-white",
          label: "General"
        };
    }
  
  };

  const assignedTeam = async (team) => {
    const data = new FormData();
    data.append("session", user.SessionId);
    data.append("id", item.id);
    data.append("assigned", team.user_id);
    data.append("status", item.status);
    try {
      const res = await axios.post(
        ENDPOINT + "admin-update-doubt-request.php",
        data,
        SecurityHeaders
      );
      if (res) {
        if (res.data.status === "success") {

          setUpdateResponse(res.data);
          Reload();
          setOpenList(false);
          dispatch({ type: 'DONE_LOADING' });
        } else {
          dispatch({ type: 'ERROR', payload: res.data.message });
        }
      }
    }
    catch (error) {
      dispatch({ type: 'ERROR', payload: error.message });
    }
  }
 

  return (
    <>
<DefaultModal 
show={openList}
HandleClose={() => setOpenList(false)}
content={
  <div className="modal-content p-3 rounded-3">
    <div className="modal-header">
      <h5 className="modal-title">Select Team</h5>
      <button type="button" className="btn-close" onClick={() => setOpenList(false)}></button>
    </div>
    <div className="modal-body scrollable" style={{ maxHeight: "400px", overflowY: "auto" }}>
      {Array.isArray(teamList)??teamList.map((team) => (
        <div key={team.id} className="d-flex justify-content-between align-items-center mb-2">
         <div className="d-flex align-items-center">
         <Avatar src={team.profile_pic ? team.profile_pic : null} />
         <h6 className="ms-2" >{team.first_name+" "+team.last_name}</h6>
         </div>
          <button className="btn btn-primary" onClick={() => { assignedTeam(team);  }}>Select</button>
        </div>
      ))}
    </div>
  </div>
}
/>
      <DefaultToast toastdata={toastdata} show={toast} />
      <DeleteModal
        deleting={deleting}
        show={deletemodal}
        HandleClose={() => setdeletemodal(false)}
        HandleDelete={() => DeleteDoubtRequest({ payload: { id: item.id } })}
      />
      <NoPermissionModal
        show={nopermission}
        HandleClose={() => setnopermission(false)}
      />


      <div className=" col-12">
        <div className="card border border-1 rounded mb-2 col-12">
          <div className="card-body p-2 p-md-3 col-12">
            <div className="d-flex align-items-center col-12 justify-content-between">
              <div className="col-lg-3 col-md-3 col-sm-12 col-12 d-flex justify-content-between">
                <div
                  to={"/students-support/" + item.id}
                  className="d-flex align-items-center w-100"
                >
                  <div className="flex-shrink-0">
                    <div className="avatar-xs rounded">
                      <img
                        src={item.profile_pic ? item.profile_pic : defaultUser}
                        alt=""
                        className="member-img img-fluid d-block rounded"
                      />
                    </div>
                  </div>
                  <div className=" my-md-3 my-0 ms-1 ms-md-3  w-100">
                    <div>
                      <h5 className="fs-16 fs-sm-14 mb-0">
                      {item.first_name + " " + item.last_name}
                    </h5>
                    <a href={`https://wa.me/91${item.phone_number}`} target="_blank" rel="noopener noreferrer" className="mb-0 pb-0 mt-1"> wh: {item.phone_number}</a>
                    
                    </div>

                    <p className="text-muted mb-0 d-md-none d-sm-block d-none  fs-sm-10">
                      {" "}
                      {item.course_url}
                    </p>

                    {options?.date === false ? (
                      <></>
                    ) : (
                      <div className="gap-2 align-items-center d-md-none d-sm-block d-block">
                        <div className="text-muted fs-sm-10">
                          {item.create_datetime}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-sm-2 d-md-none d-sm-block d-flex flex-row-reverse flex-md-row text-end">
                  <Dropdown className="options-dropdown mb-2">
                    <Dropdown.Toggle className="bg-white options p-0 w-fit h-fit  border-0">
                      <MoreVert className="text-dark" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => {
                          parseInt(permission.initiate_student_support)
                            ? UpdateRequest({ status: "initiated" })
                            : setnopermission(true);
                        }}
                      >
                        <Pending /> Initiate
                      </Dropdown.Item>

                      <Dropdown.Item
                        onClick={() => {
                          parseInt(permission.initiate_student_support)
                            // ? UpdateRequest({ status: "initiated" })
                            ?setOpenList(true)  : setnopermission(true);
                        }}
                      >
                     Assign to Teammate
                      </Dropdown.Item>

                      <Dropdown.Item
                        onClick={() => {
                          parseInt(permission.close_student_support)
                            ? UpdateRequest({ status: "closed" })
                            : setnopermission(true);
                        }}
                      >
                         <Dropdown.Item
                        onClick={() => {
                          parseInt(permission.archive_student_support)
                            ? UpdateRequest({ status: "archived" })
                            : setnopermission(true);
                        }}
                      ></Dropdown.Item>
                        <Check />
                        Closed
                      </Dropdown.Item>

                      <Dropdown.Item
                        onClick={() => {
                          parseInt(permission.delete_student_support)
                            ? setdeletemodal(true)
                            : setnopermission(true);
                        }}
                      >
                        <Delete />
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  <div className="">
                    
                    <StatusChip item={item} />
                    {(item.status === "closed" || item.status === "initiated") ? (
                      <div className="d-flex align-items-center justify-content-end">
                        <img
                          src={item.resolved_profile? item.resolved_profile:defaultUser}
                          alt=""
                          className="member-img img-fluid d-block rounded-5 col-2"
                        />
                        <p className="text-muted fs-sm-10 mb-0">{item?.resolved_user}</p>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-3 d-md-block d-sm-none d-none gap-3 mt-0 text-muted">
              <div>

<p className="text-muted mb-1">
  {item.course_url}
</p>

<div
  className={`d-inline-flex align-items-center px-2 py-1 rounded-pill ${getCategoryUI(item.category).className}`}
  style={{
    fontSize: "12px",
    gap: "5px",
    fontWeight: 500
  }}
>
  {getCategoryUI(item.category).icon}

  {getCategoryUI(item.category).label}
</div>

</div>
              </div>

              {options?.date === false ? (
                <></>
              ) : (
                <div className="col-lg-2 col-md-2 d-md-block d-sm-none d-none gap-2 align-items-center my-3 my-lg-0">
                  <div className="text-muted fs-sm-10">
                    {item.create_datetime}
                  </div>
                </div>
              )}

              <div className="col-lg-2 col-md-2 d-md-block d-sm-none d-none">
                <StatusChip item={item} />
                {
                  <div className="d-flex align-items-center pt-2">
                   {
                    item.resolved_profile ? (
                      <img
                     src={item.resolved_profile? item.resolved_profile:defaultUser}
                        alt=""
                        className="member-img img-fluid d-block rounded-5 col-2"
                      />
                    ) : (
                      null
                    )
                   }
                    <p className="text-muted mb-0 ms-2">{item?.resolved_user}</p>
                  </div>
                 }
              </div>

          

              <Dropdown className="options-dropdown col-lg-1 col-md-1 d-md-block d-sm-none d-none">
                <Dropdown.Toggle className="bg-white options p-0 w-fit h-fit  border-0">
                  <MoreVert className="text-dark" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => {
                      parseInt(permission.initiate_student_support)
                        ? UpdateRequest({ status: "initiated" })
                        : setnopermission(true);
                    }}
                  >
                    <Pending /> Initiate
                  </Dropdown.Item>


                  <Dropdown.Item
                        onClick={() => {
                          parseInt(permission.initiate_student_support)
                            // ? UpdateRequest({ status: "initiated" })
                            ?setOpenList(true)  : setnopermission(true);
                        }}
                      >
                        Assign to Teammate
                      </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      parseInt(permission.close_student_support)
                        ? UpdateRequest({ status: "closed" })
                        : setnopermission(true);
                    }}
                  >
                    <Check />
                    Closed
                  </Dropdown.Item>

                  <Dropdown.Item
                    onClick={() => {
                      parseInt(permission.delete_student_support)
                        ? setdeletemodal(true)
                        : setnopermission(true);
                    }}
                  >
                    <Delete />
                    Delete
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              {options?.view === false ? null : (
                <div className="col-lg-1 col-md-1  d-md-block d-sm-none d-none">
                  <Link
                    to={"/students-support/" + item.id}
                    className="btn btn-outline-primary"
                  >
                    View
                  </Link>
                </div>
              )}

      
            </div>
            <hr className=" d-md-none my-1"></hr>

            <div className="d-md-none">

  <p className="text-muted fs-sm-10 mb-1">
    {item.course_url}
  </p>

  <div
    className={`d-inline-flex align-items-center px-2 py-1 rounded-pill ${getCategoryUI(item.category).className}`}
    style={{
      fontSize: "11px",
      gap: "5px",
      fontWeight: 500
    }}
  >
    {getCategoryUI(item.category).icon}

    {getCategoryUI(item.category).label}
  </div>

</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentTicketItem;
